import { useEffect, useState } from 'react';
import { api } from './api';

// Registration on/off switches managed in Dashboard > Otomasi.
export const REG_DEFAULT = { creator: true, brand: true, fnb: true, home: true };

export function useRegControls() {
  const [c, setC] = useState({ ...REG_DEFAULT, loaded: false });
  useEffect(() => {
    let on = true;
    api.get('/config/registration')
      .then(({ data }) => { if (on) setC({ ...REG_DEFAULT, ...(data || {}), loaded: true }); })
      .catch(() => { if (on) setC({ ...REG_DEFAULT, loaded: true }); });
    return () => { on = false; };
  }, []);
  return c;
}

// True when a public link to a registration page should be hidden.
export const regLinkHidden = (url, c) => {
  const p = String(url || '').split('?')[0].split('#')[0];
  if (p === '/register') return c.home === false || (!c.creator && !c.brand);
  if (p === '/fnb') return c.home === false || !c.fnb;
  if (p === '/corporate') return c.home === false || !c.brand;
  return false;
};
